export default __webpack_public_path__ + "static/media/1256.40a60597.png";